module.exports = __webpack_public_path__ + "static/media/markdown-renderer.f68d203f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/projects/markdown-renderer.png
// module id = 212
// module chunks = 0